import { PersonalDetailsDto } from '../../app/models/person/personalDetailsDto';
import { WorkPostDto } from '../../app/models/workpost/workPostDto';
import { UpdateEducationCommand } from '../../app/models/person/updateEducationCommand';
import { PCSDetailsDto } from '../../app/models/pcsEnrolment/pcsDetailsDto';
import { formatDate } from '../../app/utils/util';
import registrationFormModel from '../../app/models/pcsEnrolment/registrationFormModel';

const stepFields = [
  Object.values(registrationFormModel.registrationDetailsFormField)
    .filter(field => field.name !== registrationFormModel.registrationDetailsFormField.UserConfirmation.name),
  Object.values(registrationFormModel.personalDetailsFormField),
  Object.values(registrationFormModel.educationalDetailsFormField),
  Object.values(registrationFormModel.workDetailsFormField)
];

export function getInitialEnrolmentStep(expectedStep: string | null): number {
  const step = Number(expectedStep);
  return Number.isInteger(step) && step >= 0 && step < 5 ? step : 0;
}

// Confirmation alone must not cause registration details to be saved.
export function hasStepDetailsChanges(step: number, dirtyFields: Record<string, unknown>): boolean {
  return (stepFields[step] ?? []).some(field => Boolean(dirtyFields[field.name]));
}

export function mapToRegistrationDetailsDto(form: Record<string, unknown>) {
  const data: PCSDetailsDto = {
    imcNumber: parseInt(form.IMCNumber as string),
    registrationTypeId: form.RegistrationType as string,
    schemeId: form.Scheme as string,
    specialtyId: form.Specialty as string,
    engagedInPracticeOfMedicine: form.EngagedInPracticeOfMedicine === '1',
    subSpeciality: form.SubSpecialty as string,
    declaration: (form.UserConfirmation as string).length > 0
  }
  return data;
}

export function mapToPersonalDetailsDto(form: Record<string, unknown>, personalDetails?: PersonalDetailsDto | null) {
  const data: PersonalDetailsDto = {
    id: personalDetails?.id,
    titleId: form.Title as string,
    genderId: form.Gender as string,
    nationalityId: form.Nationality as string,
    firstName: personalDetails?.firstName,
    lastName: personalDetails?.lastName,
    preferredEmail: personalDetails?.preferredEmail,
    dateOfBirth: formatDate(new Date(form.DOB as string)),
    mobile: form.MobileNumber as string
  }
  return data;
}

export function mapToUpdateEducationCommand(form: Record<string, unknown>) {
  let institution = "";
  if (form.OtherPrimaryMedicalDegreeCollege === undefined ||
    form.OtherPrimaryMedicalDegreeCollege === "") {
    institution = form.PrimaryMedicalDegreeCollege as string;
  }
  else if (form.OtherPrimaryMedicalDegreeCollege !== "") {
    institution = "";
  }

  const data: UpdateEducationCommand = {
    qualificationCountryId: form.QualificationCountry as string,
    qualificationInstitutionId: institution,
    qualificationInstitutionOther: form.OtherPrimaryMedicalDegreeCollege as string,
    qualificationYear: parseInt(form.QualificationYear as string)
  }
  return data;
}

export function mapToWorkDetailsDto(form: Record<string, unknown>) {
  const data: WorkPostDto = {
    id: null,
    startDate: formatDate(new Date(form.StartDate as string)),
    workPostLevelId: form.PostLevel as string,
    countryId: form.Country as string,
    employerId: form.NameOfEmployer as string,
    employerOther: form.NameOfEmployer === '' ? form.OtherNameOfEmployer as string : '',
    clinicalSupervisor: form.NameOfClinicalSupervisor as string,
    jobTitle: form.JobTitle as string
  }
  return data;
}

